<h3 mat-dialog-title>Ecuaciones auxiliares</h3>
<mat-dialog-content fxLayout="column" >
    
    <mat-menu #menuRef="matMenu">
        <button mat-menu-item *ngFor="let analite of importReferenceOptions" (click)="insertVariable(ecuationInput, analite.importReference, cursor)" [matTooltip]="analite.importReference"  >
            {{analite.name}} - {{analite.importReference}}
        </button>
    </mat-menu>

    <div [formGroup]="form" fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field fxFlex="20" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName='name' autocomplete="off">
            <mat-error *ngIf="form.controls.name.invalid">{{ getErrorMessage(form.controls.name)
            }}</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="60" appearance="outline">
            <mat-label>Ecuación</mat-label>
            <input #_ecuationInput (contextmenu)="ecuationInputContextMenu($event)"  matInput formControlName='value' autocomplete="off">
        </mat-form-field>

        <div *ngIf="!isEditing" fxLayout='row' fxFlex="10" fxLayoutGap='15px' fxLayoutAlign='center center'>
            <button mat-mini-fab color="primary"
                (click)="addEcuation()"
                [disabled]="disableAddLimitButton()">
                <mat-icon>add</mat-icon>
            </button>
            <button mat-mini-fab color="warn"
                (click)="removeEcuation()"
                [disabled]="disableRemoveLimitButton()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
        <div *ngIf="isEditing" fxLayout='row' fxFlex="10" fxLayoutGap='15px' fxLayoutAlign='center center'>
            <button mat-mini-fab color="primary"
                (click)="editEcuation(this.tableData, editingIndex, form.getRawValue())"
                [disabled]="disableAddLimitButton()">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab color="warn"
                (click)="cancelEditEcuation()"
                [disabled]="disableRemoveLimitButton()">
                <mat-icon>cancel</mat-icon>
            </button>
        </div>
    </div>

    <div fxLayout='column' fxFlex='1 1 200px'>
        <ag-grid-angular id='table' style="width: 100%; height: 100%;" class="ag-theme-material"
            [theme]="theme"
            [rowData]="this.tableData" [rowSelection]='rowSelection' [columnDefs]="columnDefs"
            (selectionChanged)="onSelectionChanged()" (gridReady)="onGridReady($event)" (rowDoubleClicked)="startEditRow($event)"
            [getRowStyle]="getRowStyle"
            >
        </ag-grid-angular>
    </div>

     
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button type="button" color="primary" 
     (click)="saveChanges()" >Volver</button>
    
    <button mat-button type='button' color='warn' (click)="closeDialog()">Cancelar</button>

<!-- <div *ngIf='isSaving' fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <mat-spinner diameter="30"></mat-spinner> <span>{{spinnerMessage}}</span>
</div> -->
</mat-dialog-actions>

<div 
style="position: fixed; visibility: hidden;"
[style.left]="contextMenuPosition.x"
[style.top]="contextMenuPosition.y"
[matMenuTriggerFor]="menuRef">
</div>

